import { BucketLogData, bucketLog } from '@bucketplace/bucket-log';
import React, { forwardRef, MouseEvent, ReactElement, Ref } from 'react';
import { Link, LinkProps } from '@/components/Link/Link';
import { logAmplitude } from '@/utils/Navigation/tracking';

export interface LogLinkData {
  linkType?: 'a' | 'link';
  logData?: BucketLogData;
  amplitudeType?: string;
  amplitudeData?: object;
}

export interface LogLinkProps extends LinkProps, LogLinkData {}

function LogLink(
  props: LogLinkProps,
  ref: Ref<HTMLAnchorElement>,
): ReactElement {
  const {
    linkType,
    logData,
    onClick,
    amplitudeType,
    amplitudeData = {},
    children,
    href,
    ...linkProps
  } = props;
  const isAnchor = linkType === 'a';
  const handleClick = (
    e: MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>,
  ): void => {
    if (logData) {
      bucketLog({
        category: 'click',
        ...logData,
      });
    }
    if (amplitudeType) {
      logAmplitude(amplitudeType, {
        ...amplitudeData,
      });
    }
    if (onClick) {
      onClick(e);
    }
  };

  if (isAnchor) {
    return (
      <a href={href.toString()} ref={ref} onClick={handleClick} {...linkProps}>
        {children}
      </a>
    );
  }

  return (
    <Link href={href} ref={ref} onClick={handleClick} {...linkProps}>
      {children}
    </Link>
  );
}

export default forwardRef(LogLink);
